import React from 'react';

const Footer = () => {
  return (
    <nav className="bg-primary flex justify-center py-5 relative bottom-0">
      <div className="flex-row text-white font-sans leading-4 text-base">
        © One Albania {new Date().getFullYear()}
      </div>
    </nav>
  )
}

export default Footer;

